import React from 'react';
import {ActionMenuIconButton} from '@netx/core-components/ActionMenuIconButton';
import {IconButton} from '@netx/core-components/IconButton';
import {type ReactAction} from '@netx/core/bootstrap';
import IconButtonToggle from '@netx/core-components/IconButtonToggle';

export interface ActionListItemProps {
	action: ReactAction;
	disabled?: boolean;
	loading?: boolean;
	size?: 'small' | 'medium' | 'large';
	onAction?: (action: ReactAction) => void;
	slotProps?: {
		actionMenuIconButton?: React.ComponentProps<typeof ActionMenuIconButton>;
		iconButton?: React.ComponentProps<typeof IconButton>;
		iconButtonToggle?: React.ComponentProps<typeof IconButtonToggle>;
	};
}

export const ActionListItem = ({
	action,
	disabled,
	loading,
	size = 'medium',
	onAction,
	slotProps,
}: ActionListItemProps) => {
	if (action.children?.length)
		return (
			<ActionMenuIconButton
				alwaysUseEllipsis
				disabled={disabled}
				actions={action.children}
				loading={loading}
				onAction={onAction}
				{...slotProps?.actionMenuIconButton}
				IconButtonProps={{
					color: 'inherit',
					size,
					...slotProps?.actionMenuIconButton?.IconButtonProps,
				}}
			/>
		);

	if (action.selected != null) {
		return (
			<IconButtonToggle
				iconColor="inherit"
				disabled={disabled}
				icon={action.icon}
				label={action.label}
				onToggle={() => {
					action.cb?.().then(() => {
						onAction?.(action);
					});
				}}
				on={action.selected}
				size={size}
				{...slotProps?.iconButtonToggle}
			/>
		);
	}

	return (
		<IconButton
			color="inherit"
			disabled={disabled}
			icon={action.icon}
			label={action.label}
			onClick={() => {
				action.cb?.().then(() => {
					onAction?.(action);
				});
			}}
			size={size}
			{...slotProps?.iconButton}
		/>
	);
};
